<script setup lang="ts"></script>

<template>
  <div
    class="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 p-5 w-3/4 h-3/4 sm:w-1/2 sm:h-1/2 sm:max-w-1/2 sm:max-h-1/2 bg-gray-100 border border-color-gray flex flex-col justify-center items-center rounded-3xl"
  >
    <div class="font-bold text-9xl">
      404
    </div>
    <div class="text-lg">
      Devs couldn't find that page.
    </div>
  </div>
</template>
